import ClassroomAPI from '@/apis/business/student/classroom-api.js'
import enumeration from '@/common/enumeration'

export default {
  namespaced: true,
  state: {
    // dữ liệu danh sách lớp
    classrooms: [],

    // dữ liệu của 1 lớp
    classroom: null,

    // danh sách lớp đang chờ kiểm duyệt
    classroomsWaitAppr: [],

    getClassroom: false,

    viewActive: enumeration.ClassroomType.ChooseExercise

  },

  getters: {
  },

  mutations: {
    // cập nhật danh sách lớp theo danh sách lớp học mới
    setClassrooms (state, classrooms) {
      state.classrooms = classrooms
    },

    // cập nhật lớp theo mã lớp
    setClassroom (state, classroom) {
      state.classroom = classroom
    },

    getClassroom (state) {
      state.getClassroom = !state.getClassroom
    },

    /**
     * Set active
     * @param {*} state
     * @param {*} viewActive
     * CreateBy: Nvduc 09.09
     */
    updateViewActive (state, viewActive) {
      state.viewActive = viewActive
    }
  },

  actions: {
    // lấy ra lớp học theo mã lớp
    getClassroom (context, classroom) {
      context.commit('setClassroom', classroom)
    },
    getClassroomByID (context, classId) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.getClassroom(classId).then(res => {
          context.commit('setClassroom', res.Data)
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * Lấy thông tin lớp học theo mã lớp
     * @param {*} context
     * @param {*} classCode
     * @returns
     */
    getClassroomByClassCode (context, classCode) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.getAsync(`/class-code/${classCode}`).then(res => {
          context.commit('setClassroom', res.Data)
          resolve(res.Data)
        }
        ).catch(err => {
          reject(err)
        })
      })
    },

    /**
     *  Xử lý active
     * @param {*} context
     * @param {*} viewActive
     * CreateBy: Nvduc 09.09
     */
    updateViewActive (context, viewActive) {
      context.commit('updateViewActive', viewActive)
    }

  }
}
